import React from 'react';
import { CountdownTimer } from './CountdownTimer';
const costComparison = [{
  without: '100+ hs/año planificando',
  with: '10 min/semana y a enseñar'
}, {
  without: '60% abandona antes del año',
  with: 'Retención +80% con sistema'
}, {
  without: 'Lluvia = cancelás y no cobrás',
  with: 'Plan B indoor, cobrás igual'
}, {
  without: 'Cobro irregular e incómodo',
  with: 'Abono blindado el día 25'
}];
export function FinalCTA() {
  return <section className="w-full bg-black py-12 px-4" data-id="element-66">
      <div className="max-w-3xl mx-auto text-center" data-id="element-67">
        <h2 className="text-xl sm:text-2xl font-bold text-white mb-1" data-id="element-68">
          El lunes podés volver a improvisar.
        </h2>
        <p className="text-[#00B4D8] text-xl sm:text-2xl font-black mb-8" data-id="element-69">
          O entrar a la cancha con todo resuelto.
        </p>

        {/* Cost comparison cards */}
        <div className="space-y-2 mb-8 max-w-lg mx-auto" data-id="element-70">
          {costComparison.map((row, i) => <div key={i} className="bg-[#001a2d]/60 border border-[#00B4D8]/15 rounded-xl p-3 grid grid-cols-2 gap-3" data-id="element-71">
              <div className="flex items-start gap-1.5" data-id="element-72">
                <span className="text-red-500 text-xs mt-0.5 flex-shrink-0" data-id="element-73">
                  ❌
                </span>
                <span className="text-gray-500 text-xs" data-id="element-74">{row.without}</span>
              </div>
              <div className="flex items-start gap-1.5" data-id="element-75">
                <span className="text-[#00B4D8] text-xs mt-0.5 flex-shrink-0" data-id="element-76">
                  ✅
                </span>
                <span className="text-white text-xs" data-id="element-77">{row.with}</span>
              </div>
            </div>)}
        </div>

        {/* Countdown */}
        <p className="text-white font-bold text-sm mb-2" data-id="element-78">
          ⏰ Precio de lanzamiento cierra en:
        </p>
        <div className="mb-2" data-id="element-79">
          <CountdownTimer size="md" blinking={true} data-id="element-80" />
        </div>
        <p className="text-gray-400 text-xs mb-8" data-id="element-81">
          Después sube <span className="text-[#FF0000] font-bold" data-id="element-82">$8.000</span>{' '}
          y no vuelve.
        </p>

        {/* 2 pricing cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-8 max-w-xl mx-auto" data-id="element-83">
          <div className="bg-[#0a0a0a] border border-[#00B4D8]/30 rounded-xl p-5 text-center flex flex-col" data-id="element-84">
            <h3 className="text-white font-black text-sm mb-1" data-id="element-85">📘 MEGAPACK</h3>
            <p className="text-gray-500 text-xs mb-3" data-id="element-86">6 Tomos + 6 Bonos</p>
            <div className="mt-auto" data-id="element-87">
              <span className="text-gray-500 line-through text-xs" data-id="element-88">
                $34.990
              </span>
              <p className="text-white text-xl font-black mb-3" data-id="element-89">$19.990</p>
              <a href="https://www.profepack.com/cart/48185437094144:1" className="btn-green-pulse block bg-[#00B4D8] font-black py-3 rounded-lg hover:bg-[#38BDF8] transition-colors text-sm text-white" data-id="element-90">
                → QUIERO EL MEGAPACK
              </a>
            </div>
          </div>

          <div className="relative bg-[#000d1a] border-2 border-[#00B4D8] rounded-xl p-5 text-center shadow-[0_0_20px_rgba(0,180,216,0.15)] flex flex-col" data-id="element-91">
            <div className="absolute -top-2.5 left-1/2 -translate-x-1/2" data-id="element-92">
              <span className="bg-[#00B4D8] text-black text-[10px] font-black px-3 py-0.5 rounded-full" data-id="element-93">
                ⭐ MÁS ELEGIDO
              </span>
            </div>
            <h3 className="text-[#00B4D8] font-black text-sm mb-1" data-id="element-94">
              🏆 MEGAPACK + ACADEMIA PRO
            </h3>
            <p className="text-gray-500 text-xs mb-3" data-id="element-95">
              6 Tomos + 6 Bonos + Academia Pro™
            </p>
            <div className="mt-auto" data-id="element-96">
              <span className="text-gray-500 line-through text-xs" data-id="element-97">
                $43.990
              </span>
              <p className="text-[#00B4D8] text-2xl font-black mb-3" data-id="element-98">$27.990</p>
              <a href="https://www.profepack.com/cart/48185437094144:1" className="btn-green-pulse block bg-[#00B4D8] font-black py-3 rounded-lg hover:bg-[#38BDF8] transition-colors text-sm text-white" data-id="element-99">
                → QUIERO EL PACK COMPLETO
              </a>
            </div>
          </div>
        </div>

        {/* Trust bar */}
        <div className="flex flex-wrap items-center justify-center gap-3 text-[11px] sm:text-xs text-gray-400" data-id="element-100">
          <span data-id="element-101">🔒 Pago seguro</span>
          <span data-id="element-102">⚡ Acceso en 5 min</span>
          <span data-id="element-103">🛡️ Garantía 7 días</span>
          <span data-id="element-104">💳 Mercado Pago · Tarjeta · Transferencia</span>
        </div>
      </div>
    </section>;
}